// Hero section component file
import React, { useEffect, useState } from "react";
import '../styles/HeroSection.css'

function HeroSection (){
    const [currentIndex, setCurrentIndex] = useState(0);

    // Images variable to be displayed on slideshow on herosection
    const images = [
        '/images/african-man-woman-cleaning-2.png',
        '/images/kindagigz-mobile.png',
        '/images/business-woman-on-call.png',
        '/images/kindatrade-mobile.png',
        '/images/man-viewing-platform.png'
    ];

    // Setting the slideshow to happen every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        // Hero section content
        <div 
            className="hero-section-component"
            style={{ backgroundImage: `url(${images[currentIndex]})` }}
        >
            <div className="hero-section">
                <h1>Enhancing Employment and Trade through <span>Kinda Digital</span> Solutions.</h1>
                <h3>Get Connected | Enhance Efficiency | Improve your <span>Business Acumen</span></h3>
            </div>
        </div>
    )
};

export default HeroSection;
